<template>
  <div class="hidden-sm-and-up">
    <Affix>
    <div class="mobile_nav_wrap hidden-sm-and-up">
      <div class="navbar_left" @click="gobackHome">
        <img src="@/assets/images/home/logo.png" alt="靓利建设" />
      </div>
      <div class="navbar_right">
        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
      <div class="nav_menu" ref="menu">
        <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" background-color="rgba(0,0,0,0)"
           @select="changeCurrentPage">

          <!-- <el-menu-item v-for="(item,index) in navList" :key="index" :index="index + 1" class="menu_item">{{ item.title }}</el-menu-item> -->

          <template v-for="(item, index) in navList" >
            <!-- 有子菜单的 -->
            <el-submenu v-if="item.children && item.children.length > 0" :index="(index+1).toString()" :key="index">
              <template slot="title">
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group v-for="(n, i) in item.children" :key="i">
                <el-menu-item :index="(index+1).toString()+'-'+(i+1).toString()">
                  <template>
                    <span slot="title">{{ n.name }}</span>
                </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>


            <!-- 没有子菜单的 -->
            <el-menu-item v-else :key="index" :index="(index+1).toString()">
              <template>
                <span slot="title">{{ item.name }}</span></template>
            </el-menu-item>
          </template>


        </el-menu>
      </div>
    </Affix>
    <div style="height: 98px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuShow: false,
      productShow: false,
      centerShow: false,
      fireShow: false,
      navList:[],
      activeIndex: '1',
    }
  },
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  mounted() {
    this.$request({
      url: '/pc/common',
      method: 'get',
    }).then(res => {
      this.navList = res.data.menu;
      this.company = res.data.company
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    changeCurrentPage(index) {
      this.activeIndex = index
      console.log(this.activeIndex, '111')
      switch (this.activeIndex) {
        case '1':
          this.$router.push('/home').catch((v) => { })
          break
        case '2':
          this.$router.push('/company/index').catch((v) => { })
          break
        case '3':
          this.$router.push('/news/index').catch((v) => { })
          break
        default:
          break
      }
    },
    moveMenu() {
      this.menuShow = !this.menuShow;

      if (this.menuShow) {
        this.$refs.menu.style.top = '96PX'
      } else {
        this.$refs.menu.style.top = '-1000PX'
      }
    },
    changeProductShow() {
      this.productShow = !this.productShow
      this.centerShow = false
      this.fireShow = false
    },
    changeCenterShow() {
      this.centerShow = !this.centerShow
      this.fireShow = false
      this.productShow = false
    },
    changefireShow() {
      this.fireShow = !this.fireShow
      this.centerShow = false
      this.productShow = false
    },
    gobackHome(){
      this.$router.replace('/home').catch((v) => {})
    }
  },
}
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 15PX 0 15PX 15PX;
  align-items: center;
  position: fixed;
  top: 0;
  .navbar_left {
    flex: 1;
    background: #fff;
    img {
      width: 100%;
    }
  }
  .navbar_right {
    flex: 2;
    height: 56PX;
    display: flex;
    justify-content: flex-end;
    background: #fff; 
    .nav_tiyan {
      width: 88PX;
      height: 100%;
      background: #1a63c4;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14PX;
    }

    .nav_btns {
      width: 56PX;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size: 30PX;
      }
    }
  }
}
.active{
  color: #F39C00 !important;
  font-weight: bold;
}
.nav_menu{
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    list-style: none;
    padding-bottom: 0;
    box-sizing: border-box;
    background: #EFF0F1;
    box-shadow: 0 10PX 20PX rgba(0,0,0,.1);
    z-index: 11;
    transition: all 0.8s;
    position: absolute;
    top: -1000PX;
    ::v-deep .el-submenu__title span, .el-menu-item span{
      font-size: 26px;
      padding: 20px 0;
    }
  }
</style>